module.exports = "/static/Images/es/positive.png";